import { useEffect } from 'react';
import { useAbility } from '@casl/react';
import { useCurrentUserCarePodsQuery } from 'apollo/queries/CURRENT_USER_CARE_PODS';
import { PermissionsContext, ACTIONS, SUBJECTS } from 'context/Permissions';
import useCarePodsStore from 'stores/carePods';
// Loads the current user's care pods into the store. Rendered inside the
// Permissions context so it can skip the request for users who cannot read
// care pods.
var CarePodsLoader = function () {
    var ability = useAbility(PermissionsContext);
    var canReadCarePods = ability.can(ACTIONS.READ, SUBJECTS.CARE_PODS);
    var setCarePodIds = useCarePodsStore(function (s) { return s.setCarePodIds; });
    var setCarePodNames = useCarePodsStore(function (s) { return s.setCarePodNames; });
    var data = useCurrentUserCarePodsQuery({
        fetchPolicy: 'network-only',
        skip: !canReadCarePods
    }).data;
    useEffect(function () {
        if (!(data === null || data === void 0 ? void 0 : data.current_user))
            return;
        var carePods = data.current_user.care_pods || [];
        setCarePodIds(carePods.map(function (pod) { return pod.id; }));
        setCarePodNames(carePods.map(function (pod) { return pod.name; }));
    }, [data, setCarePodIds, setCarePodNames]);
    return null;
};
export default CarePodsLoader;
